import { Orientation, PaperSize } from '../types'

const PAPER_SIZES_MM: Record<string, { width: number; height: number }> = {
  A4: { width: 210, height: 297 },
  A5: { width: 148, height: 210 },
  Letter: { width: 216, height: 279 },
}

export const getPaperDimensions = (
  paperSize: PaperSize,
  orientation: Orientation
): { width: number; height: number } => {
  const base =
    typeof paperSize === 'string'
      ? PAPER_SIZES_MM[paperSize] ?? PAPER_SIZES_MM.A4
      : { width: paperSize.widthMm, height: paperSize.heightMm }

  return orientation === 'landscape' ? { width: base.height, height: base.width } : base
}
